import * as React from "react"
import { Paper, FloatingActionButton, CircularProgress } from "material-ui"
import ContentAdd from "material-ui/svg-icons/content/add"
import autobind from "class-autobind"
import HierarchySettingsStore from "../../stores/HierarchySettingsStore"
import * as api from "../../api"
import strings from "../../localization/strings"
import * as permissionHelper from "../../helpers/permissionHelper"
import AuthenticationStore from "../../stores/AuthenticationStore"
import GitPoolItem from "../../components/gigpool/GigPoolItem"
import { IGigPoolDocument } from "../../models/documents/GigPoolDocument"
import AddEditGigPoolItem from "../../components/gigpool/AddEditGigPoolItem"

interface IState {
	gigPools: IGigPoolDocument[]
	selectedGigPoolItem: IGigPoolDocument
	loading: boolean
	globalFilterId: string
	openAddEdit: boolean
}

export default class GigPool extends React.Component<null, IState> {
	constructor(props) {
		super(props)
		this.state = {
			gigPools: [],
			loading: true,
			globalFilterId: HierarchySettingsStore.getGlobalLevelItemFilterId(),
			openAddEdit: false,
			selectedGigPoolItem: null,
		}
		autobind(this)
	}

	componentDidMount() {
		document.title = `${strings.Gig_Pool} | ${strings.Findd_Grandd_Central}`
		HierarchySettingsStore.on("change", this.changeGlobalFilter)
		this.getData()
	}

	componentWillUnmount() {
		HierarchySettingsStore.removeListener("change", this.changeGlobalFilter)
	}

	reloadLeaveTrackingTable() {
		this.getData()
	}

	changeEvent() {
		this.setState({
		}, () => this.getData())
	}

	changeGlobalFilter() {
		//HierarchySettingsStore.getGlobalLevelItemFilterId() !== this.state.globalFilterId &&
	}

	getData() {
		api.getGigPools().then((res) => {
			this.setState({ loading: false, gigPools: res.data })
		})
	}

	handleAdd(doc: IGigPoolDocument) {
		this.setState({loading: true},()=> {
			api.addGigPool(doc).then((res) => {
				this.getData()
			})
		})
	}

	update(doc: IGigPoolDocument) {
		this.setState({loading: true},()=> {
			api.updateGigPool(doc).then((res) => {
				this.getData()
			})
		})		
	}

	render() {
		return (
			<div className="page-container" style={{ position: "relative" }}>
				<div className="page-container-parent">
					{permissionHelper.hasPermission(AuthenticationStore.Permissions.LeaveTracking.AddLeaveTracking) &&
						<FloatingActionButton data-intercom-target={"menu-Leave-Tracking-Btn-Add"} className="fixed-add" style={{ top: 83, right: 40, zIndex: 998 }} secondary={true} onClick={() => this.setState({selectedGigPoolItem: null, openAddEdit: true })}>
							<ContentAdd />
						</FloatingActionButton>
					}
					<Paper zDepth={1} className="page-paper" style={{padding: 30}}>
						<h2>{strings.Gig_Pool}</h2>

						{this.state.loading &&
							<div className="spinner">
								<CircularProgress />
							</div> 
						} 

						{!this.state.loading && (!this.state.gigPools || this.state.gigPools.length === 0) &&
							<p>{strings.Gig_Pool_Empty}</p>
						}

						{!this.state.loading && this.state.gigPools && this.state.gigPools.length > 0 &&
							<div style={{display: "flex", flexWrap: "wrap"}}>								
								{
									this.state.gigPools.map((item, index) => <GitPoolItem key={index} gigPoolItem={item} onEdit={(item)=> {
										this.setState({selectedGigPoolItem: item, openAddEdit: true})
									}}/>)
								}
							</div>
						}
					</Paper>
				</div>
				{this.state.openAddEdit &&
					<AddEditGigPoolItem 
						handleClose={() =>
							this.setState({ openAddEdit: false })
						} 
						handleAdd={(payload: IGigPoolDocument) => {
							this.setState({ openAddEdit: false }, ()=>{
								this.handleAdd(payload)
							})
						}} 
						handleUpdate={(payload: IGigPoolDocument) => {
							this.setState({ openAddEdit: false }, ()=>{
								this.update(payload)
							})							
						}} 
						gigPoolDoc={this.state.selectedGigPoolItem}
					/>
				}
			</div>
		)
	}
}